import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractMotivationsService } from '../../services/motivation/motivations.abstract.service';

@Component({
  selector: 'app-driver-level',
  templateUrl: './driver-level.component.html',
  styleUrls: ['./driver-level.component.scss']
})
export class DriverLevelComponent implements OnInit{
  @Input() icon: string;
  @Input() name: string;
  @Input() level: number = 0;
  @Input() isUnknownLevelValue : boolean = false;
  @Input() hideTrendAndScore : boolean = false;
  @Input() presentRaiseLevel: boolean = false;
  @Input() showEnergyLevels: boolean = false;
  @Input() showDivider : boolean = true;
  @Input() isMemberInCareerProcess : boolean = false;
  @Output() driverIconClicked = new EventEmitter();
  @Output() driverNameClicked = new EventEmitter();

  levelColor :string = '#DFE3E8';
  levelIcon : string = "question_mark";
  presentationTrend : number;

  levelIconNames : Array<string> = ["battery_0_bar", "battery_2_bar", "battery_4_bar", "battery_5_bar", "battery_full"];
  levelIconColors : Array<string> = ["#FF4842", "#FF4842","#FFC107", "#FFC107","#54D62C"]

  noLevelDataIconName = "battery_alert";
  noLevelDataIconColor = "#DFE3E8";

  constructor(private readonly motivationsService : AbstractMotivationsService){}

  ngOnInit(): void {
    this.levelColor = this.calculateLevelColor(this.level);
    this.levelIcon = this.caclulateLevelIcon(this.level);
  }

  caclulateLevelIcon (levelValue : number): string{
    if (levelValue == 0){
      return this.noLevelDataIconName;
    }
    else {
      return this.levelIconNames[levelValue-1]; 
    }
  }

  calculateLevelColor (levelValue : number): string{
    if (levelValue == 0){
      return this.noLevelDataIconColor;
    }
    else {
      return this.levelIconColors[levelValue-1]; 
    }
  }

  onDriverIconClicked(){
    this.driverIconClicked.emit();
  }

  onDriverNameClicked(){
    this.driverNameClicked.emit();
  }
}
